/* eslint-disable prefer-object-spread */

// import store from '@api/store'

// The base API class for shared functionality
export class ApiModule {
    constructor() {

        // Globals
        this.Globals = {
            ENV: process.env.NODE_ENV, // Environment
            tenant: Object.assign({
                product: 'ambition'
            }, window.TenantGlobals || {})
        }

        // Store
        // this.$store = store

        // Testing
        if (typeof URLSearchParams === 'function') {
            const urlParams = new URLSearchParams(window.location.search)
            if (urlParams.has('app')) this.Globals.tenant.product = urlParams.get('app')
        }
    }

    isDev() { return this.getGlobal('ENV') === 'development' }
    isAmbition() { return this.getGlobal('tenant.product') === 'ambition' }
    isIgnition() { return this.getGlobal('tenant.product') === 'ignition' }

    getGlobal(globalName, defaultValue = false) {
        return _.get(this.Globals, globalName, defaultValue)
    }

    request() {
        this.log('This will call the API in a consistent way...')
    }

    log(txt) {
        const message = [
            `%cAmbition API%c${txt}`,
            'background: #222; color: #09FE02; padding: 5px 10px; border: 1px solid #222;',
            'color: red; padding: 5px 10px; border: 1px solid #222;'
        ]
        if (typeof txt !== 'string') message.push(txt)
        console.log(...message)
    }

    help() {
        this.log('Open ./docs/index.html from the project root directory for API documentation.')
    }

    test() {
        this.log('Hello...?')
    }

    user() {
        return this.getGlobal('tenant.user');
    }

    userId() {
        return this.getGlobal('tenant.userId');
    }

    tenant() {
        return this.getGlobal('tenant.tenant')
    }

    applicationId() {
        return this.getGlobal('tenant.applicationId')
    }

    useEmailBuilder() {
        return this.getGlobal('tenant.useEmailBuilder');
    }

    useApplicationAudits() {
        return this.getGlobal('tenant.useApplicationAudits');
    }

    deferredInsurance() {
        return this.getGlobal('tenant.deferredInsurance');
    }

    deferredInsuranceLenderApproval() {
        return this.getGlobal('tenant.deferredInsuranceLenderApproval');
    }

    deferredInsuranceSendAndSettle() {
        return this.getGlobal('tenant.deferredInsuranceSendAndSettle');
    }

    deferredInsuranceAssetAndSeller() {
        return this.getGlobal('tenant.deferredInsuranceAssetAndSeller');
    }

    customerReviewRequest() {
        return this.getGlobal('tenant.customerReviewRequest');
    }

    auditChecklistRequired() {
        return this.getGlobal('tenant.auditChecklistRequired');
    }

    tenantId() {
        return this.getGlobal('tenant.tenantId')
    }

    currentTeamId() {
        return this.getGlobal('tenant.currentTeamId');
    }

    teamsEnabled() {
        return this.getGlobal('tenant.teams_enabled');
    }

    isCrmActive() {
        return this.getGlobal('tenant.isCrmActive');
    }

    teams() {
        return this.getGlobal('tenant.teams');
    }

    pepperSubmissions() {
        return this.getGlobal('tenant.pepperSubmissions');
    }

    hasRoleOrPermission(roleOrPermission, userObject) {

        let user = typeof userObject !== 'undefined' ? userObject : this.getGlobal('tenant.user')

        let rolePermissions = _.uniqBy(_.flatten(user.roles.map(userRole => userRole.permissions)), 'name')
        let allPermissions = _.uniqBy([...user.permissions, ...rolePermissions], 'name')
        let rolesAndPermissions = [...user.roles, ...allPermissions]

        rolesAndPermissions = rolesAndPermissions.filter(rolesAndPermission => rolesAndPermission)

        if (_.isArray(roleOrPermission)) {
            return rolesAndPermissions.some((userPermission) => roleOrPermission.includes(userPermission.name))
        }
        return rolesAndPermissions.some((userPermission) => userPermission.name == roleOrPermission)
    }

    sendFinanceQuote() {
        return this.getGlobal('tenant.sendFinanceQuote');
    }

    brokerEmailPhoneOverrides() {
        return this.getGlobal('tenant.brokerEmailPhoneOverrides') == 1 ? true : false
    }

    allowCommissionOverride() {
        return this.getGlobal('tenant.allowCommissionOverride') == 1 ? true : false
    }

    creditCheckBlockEnabled() {
        return this.getGlobal('tenant.creditCheckBlockEnabled') == 1 ? true : false
    }

    qualifyingQuestionnaireEnabled() {
        return this.getGlobal('tenant.qualifyingQuestionnaireEnabled') == 1 ? true : false
    }

    bidDisclosureEnabled() {
        return this.getGlobal('tenant.bidDisclosureEnabled') == 1 ? true : false
    }

    enableConsumerCreditGuideAndQuote() {
        return this.getGlobal('tenant.enableConsumerCreditGuideAndQuote') == 1 ? true : false
    }

    enableCommercialCreditGuideAndQuote() {
        return this.getGlobal('tenant.enableCommercialCreditGuideAndQuote') == 1 ? true : false
    }

    enableQuoteFastTrack() {
        return this.getGlobal('tenant.enableQuoteFastTrack') == 1 ? true : false
    }

    enableLoanOptionsAmbitionCloud() {
        return this.getGlobal('tenant.enableLoanOptionsAmbitionCloud') == 1 ? true : false
    }

    useVwPrivacyStatements() {
        return this.getGlobal('tenant.use_privacy_statement_vw') == 1 ? true : false
    }

    useMacPrivacyStatements() {
        return this.getGlobal('tenant.use_privacy_statement_mac') == 1 ? true : false
    }
}
